"use client";

import { MapPin, Phone, Mail } from "lucide-react";
import { useLanguage } from "@/context/LanguageContext";

export default function MapSection() {
  const { t } = useLanguage();
  return (
    <section className="relative bg-[#040d21]" id="ban-do">
      <div className="flex flex-col lg:relative lg:h-[600px]">
        {/* Map Container */}
        <div className="h-[400px] lg:h-full w-full order-1 lg:order-none">
          <iframe
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3713.6088005502806!2d105.860542!3d21.444616199999995!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x31351fae7c5b1f5f%3A0xa60d9d53b10837c0!2zQ8O0bmcgVHkgVE5ISCBDw7RuZyBOZ2jhu4cgVsOgIEThu4tjaCBW4bulIEFIVg!5e0!3m2!1sen!2s!4v1774239909393!5m2!1sen!2s"
            width="100%"
            height="100%"
            style={{ border: 0 }}
            allowFullScreen
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
            title="AHV Holding Office Location"
            className="grayscale hover:grayscale-0 transition-all duration-700"
          ></iframe>
        </div>

        {/* Overlay Office Cards */}
        <div className="hidden lg:block absolute inset-0 bg-gradient-to-r from-brand-dark/80 via-brand-dark/40 to-transparent pointer-events-none z-10"></div>
        
        <div className="relative lg:absolute lg:top-0 lg:left-0 lg:h-full lg:flex lg:items-center z-20 order-2 lg:order-none py-12 lg:py-0">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 w-full">
            <div className="max-w-md">
              <h3 className="text-3xl lg:text-4xl font-black text-white mb-8 tracking-tighter">
                {t("home.map.title").split(" ")[0]} <span className="text-[#00f3ff] drop-shadow-[0_0_10px_rgba(0,243,255,0.3)]">{t("home.map.title").split(" ").slice(1).join(" ")}</span>
              </h3>
              <div className="grid grid-cols-1 gap-6">
                {/* Office 1 */}
                <div className="group bg-white/5 backdrop-blur-xl rounded-2xl p-6 border border-white/10 hover:border-[#00f3ff]/30 transition-all duration-500">
                  <h4 className="text-white font-black mb-3 flex items-center gap-3 text-lg leading-tight">
                    <div className="w-10 h-10 rounded-xl bg-blue-600/20 flex items-center justify-center text-[#00f3ff]">
                      <MapPin className="w-5 h-5" />
                    </div>
                    {t("home.map.offices.tn.name")}
                  </h4>
                  <p className="text-slate-400 text-sm font-medium leading-relaxed mb-4 pl-1">
                    {t("home.map.offices.tn.address")}
                  </p>
                  <div className="flex flex-col gap-3 text-xs text-slate-500 font-bold pl-1">
                    <span className="flex items-center gap-3 hover:text-white transition-colors">
                      <Phone className="w-4 h-4 text-[#00f3ff]" /> (+84) 393 797 791
                    </span>
                    <span className="flex items-center gap-3 hover:text-white transition-colors">
                      <Mail className="w-4 h-4 text-[#00f3ff]" /> hr@ahvholding.com
                    </span>
                  </div>
                </div>
                {/* Office 2 */}
                <div className="group bg-white/5 backdrop-blur-xl rounded-2xl p-6 border border-white/10 hover:border-[#00f3ff]/30 transition-all duration-500">
                  <h4 className="text-white font-black mb-3 flex items-center gap-3 text-lg leading-tight">
                    <div className="w-10 h-10 rounded-xl bg-cyan-600/20 flex items-center justify-center text-[#00f3ff]">
                      <MapPin className="w-5 h-5" />
                    </div>
                    {t("home.map.offices.hn.name")}
                  </h4>
                  <p className="text-slate-400 text-sm font-medium leading-relaxed mb-4 pl-1">
                    {t("home.map.offices.hn.address")}
                  </p>
                  <div className="flex flex-col gap-3 text-xs text-slate-500 font-bold pl-1">
                    <span className="flex items-center gap-3 hover:text-white transition-colors">
                      <Phone className="w-4 h-4 text-[#00f3ff]" /> (+84) 24 987 654
                    </span>
                    <span className="flex items-center gap-3 hover:text-white transition-colors">
                      <Mail className="w-4 h-4 text-[#00f3ff]" /> hn@ahvholding.com
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
